import script from "./MenuSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSection.vue?vue&type=script&setup=true&lang=js"

import "./MenuSection.vue?vue&type=style&index=0&id=5721bdbc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5721bdbc"]])

export default __exports__